"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconProfile = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 20",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M10,0 C4.48,0 0,4.48 0,10 C0,15.52 4.48,20 10,20 C15.52,20 20,15.52 20,10 C20,4.48 15.52,0 10,0 Z M5.07,16.28 C5.5,15.38 8.12,14.5 10,14.5 C11.88,14.5 14.51,15.38 14.93,16.28 C13.57,17.36 11.86,18 10,18 C8.14,18 6.43,17.36 5.07,16.28 Z M16.36,14.83 C14.93,13.09 11.46,12.5 10,12.5 C8.54,12.5 5.07,13.09 3.64,14.83 C2.62,13.49 2,11.82 2,10 C2,5.59 5.59,2 10,2 C14.41,2 18,5.59 18,10 C18,11.82 17.38,13.49 16.36,14.83 L16.36,14.83 Z M10,4 C8.06,4 6.5,5.56 6.5,7.5 C6.5,9.44 8.06,11 10,11 C11.94,11 13.5,9.44 13.5,7.5 C13.5,5.56 11.94,4 10,4 Z M10,9 C9.17,9 8.5,8.33 8.5,7.5 C8.5,6.67 9.17,6 10,6 C10.83,6 11.5,6.67 11.5,7.5 C11.5,8.33 10.83,9 10,9 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconProfile')(IconProfile);